import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MaterialModule } from "./material.module";
import { TooltipComponent } from "./common/UI-Components/tooltip/tooltip.component";
import { TooltipDirective } from "./Directives/tooltip.directive";
import { InputBoxComponent } from "./common/UI-Components/input-box/input-box.component";
import { RadioGroupComponent } from "./common/UI-Components/radio-group/radio-group.component";
import { InputFileComponent } from "./common/UI-Components/input-file/input-file.component";
import { MultilineBoxComponent } from "./common/UI-Components/multiline-box/multiline-box.component";
import { LoadingCircleComponent } from "./common/UI-Components/loading-circle/loading-circle.component";
import { TabsComponent } from "./common/UI-Components/tabs/tabs.component";


const modules = [
  CommonModule,
  FormsModule,
  MaterialModule
];

const declarations = [
  TooltipComponent,
  TooltipDirective,
  InputBoxComponent,
  MultilineBoxComponent,
  RadioGroupComponent,
  InputFileComponent,
  LoadingCircleComponent,
  TabsComponent
];
@NgModule({
    imports: [
        ...modules,
        ...declarations
    ],
    exports: [
        ...declarations,
        ...modules
    ]
})
export class SharedModule { }
